import { Component, Vue, Model } from 'vue-property-decorator';
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb';
import Divider from '@/components/Breadcrumbs/Divider';

@Component<Breadcrumbs>({
  name: 'mi-breadcrumbs',
  components: {
    'mi-breadcrumb': Breadcrumb,
    'mi-breadcrumb-divider': Divider,
  },
})
export default class Breadcrumbs extends Vue {
  @Model('crumbs') crumbs!: string[];
}
